import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import translations from '@nike/gameday-translations/web';
import { getUserData } from '../user/selectors';

import { LOCALE_USA } from '../static/languagePicker/constants';

const WithTranslations = ({ user, children }) => {
  const lang = (user && user.locale ? user.locale : LOCALE_USA).replace(/_.*$/, '');
  sessionStorage.setItem('locale', lang);
  return (
    <IntlProvider locale={lang} messages={translations[lang]} key={user && user.lastLogin}>
      {children}
    </IntlProvider>
  );
};

const mapStateToProps = state => ({
  user: getUserData(state)
});

WithTranslations.defaultProps = {
  user: { locale: LOCALE_USA }
};

WithTranslations.propTypes = {
  user: PropTypes.object,
  children: PropTypes.node.isRequired
};

const connector = connect(mapStateToProps, {});

export default connector(WithTranslations);
